import $ from 'jquery';
import { pickerCfg } from 'pickerCfg';
import contentTemplate from 'properties/style/table-row-text.ejs';
import BasePropertyView from 'BasePropertyView'
import themeService     from 'ThemeService';
import fontService from '../../../service/FontService';

class StyleTableRowTextView extends BasePropertyView {

    initialize( opts ) {
        super.initialize( opts );

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #fontFamily, #fontSize, #customButtonFontFamily' : 'updateAttributes',
            'click #boldText, #italicText' : 'updateTextStyleAttributes',
            'change #styleColorTextPicker' : 'updateColorAttributes',
            'change #styleColorText' : 'updateColorAttributesWithValidation'
        };

        let currentFont = this.resolveThemeFontProperty('fontFamily');
        fontService.initCustomFont(this.model, currentFont, true);


        return this;
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        var weight = this.model.get('textWeight');
        var style = this.model.get('textStyle');

        if(propName === 'textWeight') {
            if(this.model.get('textWeight')==='bold') {
                this.model.set('boldSelection', this.unselectedColor, {silent:true});
                weight = 'normal';
            } else {
                this.model.set('boldSelection', this.selectedColor, {silent:true});
                weight = 'bold';
            }
        }

        if(propName === 'textStyle') {
            if(this.model.get('textStyle') === 'italic') {
                this.model.set('italicSelection', this.unselectedColor, {silent:true});
                style = 'normal';
            } else {
                this.model.set('italicSelection', this.selectedColor, {silent:true});
                style = 'italic';
            }
        }

        this.model.set( 'textWeight', weight, {silent:true} );
        this.model.set( 'textStyle', style , {silent:true});
        this.model.trigger('change', this.model);
    }

    selectMask(value) {
        switch (value) {
            case 'bold': return this.selectedColor;
            case 'italic': return this.selectedColor;
            default: return this.unselectedColor;
        }
    }

    resolveAttributes(base, name) {
        let fontPropsArray = themeService.resolve(base).split(',');
        let result = 'normal !important';
        if (name === 'textWeight') {
            if (fontPropsArray[2]) {
                result = fontPropsArray[2].trim().toLowerCase();
            }
        } else {
            if (fontPropsArray[3]){
                result =  fontPropsArray[3].trim().toLowerCase();
            }
        }
        return result;
    }

    updateAttributes(ev, columnModel = undefined, name = undefined, value = undefined) {
        let
            propName = ev.currentTarget.name || name,
            propVal = ev.currentTarget.name ? ev.currentTarget.value : value,
            oldValue = this.model.get(propName);

        const webFont = fontService.webFonts.find(font => font.name === propVal);

        if (webFont) {
            fontService.loadWebFontResource(webFont);
        }

        if(propName === "customButtonFontFamily" || propName === "fontFamily"){
            propVal = fontService.updateCustomFont(this.model, propVal, true);
            this.model.set('fontFamily', propVal);
        }
        
        super.updateAttributes(ev, columnModel, name, value);

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
    }

    updateForm() {
        //set selected index to model value
        if(this.model.get('fontSize')) {
            $('#fontSize')
                .find(`option[value="${this.resolveThemeFontProperty('fontSize')}"]`)
                .attr(`selected`, true);
        }
        if (this.model.get('fontFamily')) {
            let font = this.resolveThemeFontProperty('fontFamily');
            const customFont = fontService.isCustomFont(font);
            font = !customFont ? font : "__custom__";
            $('#fontFamily').find('option[value="' + font + '"]').attr('selected', true);
            
        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['styleHeaderColorText']);

        if ( this.isThemeProperty(props.textWeight)) {
            props.textWeight = this.resolveAttributes(props.textWeight, 'textWeight');
            props.boldSelection = this.selectMask(props.textWeight);
        }
        if ( this.isThemeProperty(props.textStyle)) {
            props.textStyle = this.resolveAttributes(props.textStyle, 'textStyle');
            props.italicSelection = this.selectMask(props.textStyle);
        }
        
        this.$el.html(this.template( props ));

        const fonts = fontService.loadFontsDropDown(true);
        $("#fontFamily").append(fonts);

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.updateForm();
        this.delegateEvents();

        return this;
    }
}

export default StyleTableRowTextView;
